module.exports = __webpack_public_path__ + "img/p4.2cb4a3f8.png";